import JenisKayuApi from './JenisKayuApi';

export default JenisKayuApi;
